import { notifications } from '@mantine/notifications';
import { createNotification, createNotificationMethods, modalHandler } from './notifications.helpers';
import type { NotificationConfig } from './notifications.type';

/**
 * Shows a notification with the specified configuration
 *
 * @param {NotificationConfig} config - Configuration object for the notification
 * @returns {string} The unique ID of the created notification
 */
const showNotification = (config: NotificationConfig): string => {
  return createNotification(config, modalHandler || undefined);
};

/**
 * Destructure notification methods for success, warning and error notifications
 * Created using the showNotification function as base
 *
 * @property {Function} showSuccess - Shows a success notification
 * @property {Function} showWarning - Shows a warning notification
 * @property {Function} showError - Shows an error notification
 */
const { showSuccess, showWarning, showError } = createNotificationMethods(showNotification);

/**
 * Global toast object that provides methods for showing different types of notifications
 * @property {Function} show - Shows a notification with custom configuration
 * @property {Function} success - Shows a success notification
 * @property {Function} warning - Shows a warning notification
 * @property {Function} error - Shows an error notification
 * @property {Function} hide - Hides a specific notification by ID
 * @property {Function} clean - Removes all notifications
 */
const toast = {
  show: showNotification,
  success: showSuccess,
  warning: showWarning,
  error: showError,
  hide: notifications.hide,
  clean: notifications.clean,
};

export { toast };
